export const TPA_EXPERIMENTS = {
  USE_BLOCKS_PLAN_LIST_WIDGET: 'specs.membership.UseBlocksPlanListWidget',
  USE_BLOCKS_PACKAGE_PICKER_PAGE: 'specs.membership.UseBlocksPackagePickerPage',
  INSTALL_SPLIT_PAGES: 'specs.membership.InstallSplitPages',
  ROUTER: 'specs.membership.EnableRouter',
  ROUTER_MIGRATION: 'specs.membership.RouterMigration',
  ROUTE_PAYWALL: 'specs.membership.RoutePaywall',
  SINGLE_PLAN_NEW_PRESETS_PANEL: 'specs.membership.SinglePlanNewPresetsPanel',
  SINGLE_PLAN_ELEMENT_PANEL_SUBTITLE: 'specs.membership.SinglePlanElementPanelSubtitle',
  FIX_STUDIO_BLOCKS_PLAN_CARD: 'specs.membership.FixStudioBlocksPlanCard'
};
//# sourceMappingURL=tpa.js.map